"use client"

import { SquareMinus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareMinusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareMinusIcon = component(Icon)({ as: SquareMinus })
